import classNames from 'classnames';
import { CONNECTED_ENUM } from './constants';

const getBackground = (status) => {
  switch (status) {
    case CONNECTED_ENUM.disconnected:
      return 'bg-red-500';
    case CONNECTED_ENUM.connected:
      return 'bg-green-500';
    default:
      return 'bg-gray-700';
  }
};

const StatusIcon = (props) => (
  <div
    className={classNames(
      'rounded-lg',
      'size-4',

      getBackground(props.status),
    )}
  />
);

export default StatusIcon;
